module.exports = __webpack_public_path__ + "static/sofia-artist-profile-cd1da2c3445d3cde008fdce75f8e0b3e.jpg";